export const state = () => ({
  info: {},
  serverList: []
})

export const mutations = {
  setGame(state, game) {
    state.info = game || {
      game_intro_list: [],
      slice_list: [],
      notice_list: [],
      role_intro_list: [],
      screen_list: []
    }
  },
  setServerList(state, list) {
    state.serverList = list
  }
}

export const actions = {
  getGameDetail({ commit }, game_id) {
    return this.$request('gameHome', {
      body: { game_id }
    }).then((data) => commit('setGame', data))
  },
  getServerList({ state, commit }, game_id) {
    return this.$request('gameServerList', {
      body: { game_id }
    }).then((arr = []) => commit('setServerList', arr))
  }
}
